import script from "./IconGas4.vue?vue&type=script&lang=ts&setup=true"
export * from "./IconGas4.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__